<div class="main-container">
    <div class="center-container">
        <div>
            <img src="assets/images/deep-link.png" >
            <div class="center-text">{{deepLinkText}}</div>
        </div>
    </div>
</div>
